export default {"src":"/_next/static/media/paypal.23e43cbf.svg","height":32,"width":101};